import React, { useCallback, useContext, useEffect, useState } from "react"
import * as AppConstants from "../../../../utility/AppConstants"
import InfoRiservatezza from "../../../avvisi/InfoRiservatezza"
import InfoTotali from "../../../avvisi/InfoTotali"
import "Css/table.css"
import { Table } from "@sogei/react-web-components-catalog"
import { Indexable, ResponseDatiRegionaliMultiAnno } from "@/utility/model"
import { MultiAnnoContext } from "@/context/MultiAnnoContext"
interface TabTotaliProps {
    datiRegionali: (ResponseDatiRegionaliMultiAnno & Indexable<any>)[]
    datoToVisualize: string
    codIsa: string
    macroarea?: string | null
    anno: string
    codiciIsa: string[]
}

function TabTotaliMultiAnno({
    datiRegionali,
    datoToVisualize,
    codiciIsa,
    ...props
}: TabTotaliProps) {
    const [multiAnnoState, _] = useContext(MultiAnnoContext)

    let infoCodIsa =
        props.codIsa != "@@" &&
        props.codIsa != "" &&
        [...new Set(codiciIsa)].length > 1
            ? codiciIsa.map((cod) => ` (${cod})`)
            : ["", "", ""]

    let ordinati = datiRegionali
        .filter((d) => d.anno == props.anno)
        .sort(
            (
                a: ResponseDatiRegionaliMultiAnno,
                b: ResponseDatiRegionaliMultiAnno
            ) => {
                return a.regione.localeCompare(b.regione, "it", {
                    sensitivity: "base"
                })
            }
        )

    let itemToRemove = ordinati.find((e) => e.regione === "Totale")
    if (itemToRemove != undefined) {
        ordinati = ordinati.filter((a) => a != itemToRemove)
        ordinati.push(itemToRemove)
    }

    return (
        <div id="tab-reverse-1">
            <div className="row">
                <div className="col-12 ">
                    <div className="table-responsive">
                        <Table
                            tableHead={
                                <tr>
                                    <th style={{ width: 240 }}>
                                        {AppConstants.TITLE_REGIONE.toUpperCase()}
                                    </th>
                                    <th className="th-statistiche">
                                        {props.anno}
                                        {infoCodIsa[0]}
                                    </th>
                                    <th className="th-statistiche">
                                        {Number(props.anno) + 1}
                                        {infoCodIsa[1]}
                                    </th>
                                    <th className="th-statistiche">
                                        {Number(props.anno) + 2}
                                        {infoCodIsa[2]}
                                    </th>
                                </tr>
                            }
                            tableBody={
                                datiRegionali !== undefined &&
                                datiRegionali.length > 0 &&
                                ordinati.map((dati, key) => {
                                    let datiPrimo = datiRegionali.find(
                                        (e) =>
                                            e.regione
                                                .replace("-", " ")
                                                .split("/")[0] ==
                                                dati.regione
                                                    .replace("-", " ")
                                                    .split("/")[0] &&
                                            Number(e.anno) ===
                                                Number(props.anno)
                                    )

                                    let datiSecondo = datiRegionali.find(
                                        (e) =>
                                            e.regione
                                                .replace("-", " ")
                                                .split("/")[0] ==
                                                dati.regione
                                                    .replace("-", " ")
                                                    .split("/")[0] &&
                                            Number(e.anno) ===
                                                Number(props.anno) + 1
                                    )
                                    let datiTerzo = datiRegionali.find(
                                        (e) =>
                                            e.regione
                                                .replace("-", " ")
                                                .split("/")[0] ==
                                                dati.regione
                                                    .replace("-", " ")
                                                    .split("/")[0] &&
                                            Number(e.anno) ===
                                                Number(props.anno) + 2
                                    )

                                    return (
                                        <tr className="tableStatIsa" key={key}>
                                            {dati.regione.toUpperCase() ===
                                            AppConstants.TITLE_TOTALE ? (
                                                <th>
                                                    {dati.regione.toUpperCase()}{" "}
                                                    *
                                                </th>
                                            ) : (
                                                <th>{dati.regione}</th>
                                            )}
                                            <td>
                                                {datiPrimo?.[datoToVisualize]}
                                            </td>
                                            <td>
                                                {datiSecondo?.[datoToVisualize]}
                                            </td>
                                            <td>
                                                {datiTerzo?.[datoToVisualize]}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            //tableOptions={["table-striped"]}
                        >
                            <caption className="sr-only">
                                {AppConstants.TITLE_REGIONE}
                            </caption>
                        </Table>
                    </div>
                </div>
            </div>

            {datiRegionali !== undefined && datiRegionali.length > 0 ? (
                <InfoRiservatezza />
            ) : null}
            {datiRegionali !== undefined && datiRegionali.length > 0 ? (
                <InfoTotali />
            ) : null}
        </div>
    )
}
export default TabTotaliMultiAnno
